import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  user-select: none;
  p {
    margin-bottom: 0.4rem;
  }
`;
